import { v1 as uuidv1 } from 'uuid';
import { List, Record as record } from 'immutable';

import { construct, fields, resolve, resolveAll } from '../helpers/LinkMapper';
import TicketPassenger from './TicketPassenger';
import Ticket from './Ticket';
import TicketType from './TicketType';

export class Pax extends record({ id: '', ticket: null, orderTicketId: null, name: '' }) {
    static fromJSON (json = {}) {
        json.id = uuidv1();
        return construct(Pax, json, {
            id: fields.string,
            ticket: resolve.as(Ticket),
            name: fields.string,
            orderTicketId: fields.number
        });
    }

    getError() {
        const { ticket, name } = this;
        return new TicketPassenger({ ticket, name }).getError('name');
    }
}

export default class Passengers extends record({ pax: new List(), ticketType: null }) {

    static fromTickets (ticketType, tickets = new List()) {
        let passengers = new Passengers({ ticketType });
        tickets.forEach((ticket) => {
            passengers = passengers.set('pax', passengers.pax.push(Pax.fromJSON({ ticket })));
        });
        return passengers;
    }

    static fromJSON (json = {}) {
        return construct(Passengers, json, {
            pax: resolveAll.as(Pax),
            ticketType: resolve.as(TicketType)
        });
    }

    getRequestJSON() {
        return {
            passengers: this.pax.map((pax) => new TicketPassenger({ ticket: pax.orderTicketId, name: pax.name })).toJS()
        };
    }

    setName (pax, name) {
        const paxIndex = this.pax.findIndex((p) => p.id === pax.id);
        if (paxIndex > -1) {
            return this.setIn(['pax', paxIndex, 'name'], name);
        }
        return this;
    }

    setTicketIds (orderTickets) {
        let ticketPool = orderTickets.toSet();
        const passengers = this.pax.map((pax) => {
            const { ticket } = pax;
            const orderTicket = ticketPool.find((ot) => (
                ticket.children === ot.children
                    && ticket.adults === ot.adults
                    && ticket.getIn(['railcard', 'code']) === ot.getIn(['railcard', 'code'])
            ));
            if (orderTicket) {
                ticketPool = ticketPool.delete(orderTicket);
                pax = pax.set('orderTicketId', orderTicket.id);
            }
            return pax;
        });
        return this.set('pax', passengers);
    }

    isComplete() {
        return this.pax.every((pax) => !pax.getError());
    }

    isEmpty() {
        return this.pax.size === 0;
    }
}
